<template functional>
  <span class="red pending-alert">!</span>
</template>
<script>
export default {
  name: "AppAlertIcon"
};
</script>
<style scoped>
.pending-alert {
  border-radius: 50% !important;
  font-weight: bold;
  color: white;
  padding: 4px 12px;
  margin-right: 9px;
  font-size: 18px;
}
</style>
